import { PropTypes } from 'prop-types';
import FJAppLeft from '../../../../components/FJMainPreview/FJAppLeft/FJAppLeft';
import FJGenerateButton from '../../../../common/components/FJGenerateButton/FJGenerateButton';
import FJVerticalScroller from '../../../../common/components/FJScroller/FJVerticalScroller';
import FJAIPhotoEditorPromptContainer from '../container/FJAIPhotoEditorPromptContainer';
import FJAIPhotoEditorPresetListContainer from '../container/FJAIPhotoEditorPresetListContainer';
import FJAIPhotoEditorModelSelectorContainer from '../container/FJAIPhotoEditorModelSelectorContainer';
import FJAIPhotoEditorMultipleImageUploaderContainer from '../container/FJAIPhotoEditorMultipleImageUploaderContainer';
import { AI_PHOTO_EDITOR_MODELS } from '../../../../config/dataConfig/FJAIPhotoEditorData';

import styles from './FJAIPhotoEditorLeft.module.less';
import { useMemo } from 'react';
import FJAIPhotoEditorRatioContainer from '../container/FJAIPhotoEditorRatioContainer';
import FJAIPhotoEditorResolutionContainer from '../container/FJAIPhotoEditorResolutionContainer';
import FJGeneratePrivacySettingsContainer from '../container/FJGeneratePrivacySettingsContainer.jsx';

const FJAIPhotoEditorLeft = ({
    onGenerate,
    taskStatus,
    freeNumCreation,
    isFree,
    isProjectLoading,
    curModel,
    curResolution,
    supportImageReferenceNum = false,
}) => {
    const useCredit = useMemo(() => {
        const currentModel = AI_PHOTO_EDITOR_MODELS.find(item => item.value === curModel);
        const useCredit =
            (currentModel?.creditPriceLevels && currentModel?.creditPriceLevels?.[curResolution]) ||
            currentModel?.useCredit ||
            0;
        return useCredit;
    }, [curModel, curResolution]);

    return (
        <FJAppLeft className={styles.app_left}>
            <div className={styles.container}>
                <FJVerticalScroller className={styles.scroller}>
                    <FJAIPhotoEditorModelSelectorContainer />
                    <div className={styles.upload_box}>
                        <FJAIPhotoEditorMultipleImageUploaderContainer
                            supportImageReferenceNum={supportImageReferenceNum}
                        />
                    </div>
                    <FJAIPhotoEditorPromptContainer />
                    {/*<FJAIPhotoEditorResolutionContainer />*/}
                    {/*<FJAIPhotoEditorRatioContainer />*/}
                    <FJAIPhotoEditorPresetListContainer />
                </FJVerticalScroller>
            </div>
            <div className={styles.generate_button_box}>
                <FJAIPhotoEditorResolutionContainer />
                <FJAIPhotoEditorRatioContainer />
                <FJGeneratePrivacySettingsContainer />
                <FJGenerateButton
                    onClick={onGenerate}
                    taskStatus={taskStatus}
                    freeNumCreation={freeNumCreation}
                    isFree={isFree}
                    useCredit={useCredit}
                    isProjectLoading={isProjectLoading}
                    isShowUsageDetail={true}
                    style={{ flex: 1 }}
                />
            </div>
        </FJAppLeft>
    );
};

FJAIPhotoEditorLeft.propTypes = {
    onGenerate: PropTypes.func,
    taskStatus: PropTypes.string,
    freeNumCreation: PropTypes.number,
    isFree: PropTypes.bool,
    isProjectLoading: PropTypes.bool,
    curModel: PropTypes.string,
    curResolution: PropTypes.string,
    supportImageReferenceNum: PropTypes.number,
};

export default FJAIPhotoEditorLeft;
